import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import Copyright from "../../internals/components/Copyright";
import WithdrawalReport from "../withdrawal/WithdrawalReport";
import { UserType } from "../../enums/userType";

const AgentWithdrawal = ({ token, id, isAuthenticated, setIsAuthenticated }) => {
	return (
		<Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
			{/* cards */}
			<Typography component="h2" variant="h6" sx={{ mb: 2 }}>
				Account Withdrawals
			</Typography>
			<Grid container columns={12}>
				<Grid size={{ xs: 12, md: 12, lg: 12 }}>
					<WithdrawalReport
						token={token}
						id={id}
						isAuthenticated={isAuthenticated}
						setIsAuthenticated={setIsAuthenticated}
						userType={UserType.AGENT}
					/>
				</Grid>
			</Grid>
			<Copyright sx={{ my: 4 }} />
		</Box>
	);
};

export default AgentWithdrawal;
